import { render, staticRenderFns } from "./BackendTracking.vue?vue&type=template&id=b424ca72&"
import script from "./BackendTracking.vue?vue&type=script&lang=js&"
export * from "./BackendTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports